import { render, staticRenderFns } from "./jifenMy.vue?vue&type=template&id=f2cf0b9a&scoped=true"
import script from "./jifenMy.vue?vue&type=script&lang=js"
export * from "./jifenMy.vue?vue&type=script&lang=js"
import style0 from "./jifenMy.vue?vue&type=style&index=0&id=f2cf0b9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2cf0b9a",
  null
  
)

export default component.exports